/* Kleine sprachliche Korrekturen fuer von Boost dynamisch erzeugte
   Texte. Filterdaten, Trefferzahlen und Navigation bleiben unveraendert. */
(function () {
  var geplant = false;

  function eindeutschen() {
    geplant = false;

    document.querySelectorAll('.template-collection h1.boost-sd__header-title').forEach(function (element) {
      var ersatz = document.createElement('div');
      Array.from(element.attributes).forEach(function (attribut) {
        ersatz.setAttribute(attribut.name, attribut.value);
      });
      ersatz.innerHTML = element.innerHTML;
      element.replaceWith(ersatz);
    });

    document.querySelectorAll('.template-collection .boost-sd__product-count').forEach(function (element) {
      var text = element.textContent.trim();
      var treffer = text.match(/^(\d[\d.]*)\s+products?$/i);
      if (treffer) element.textContent = treffer[1] + ' Artikel';
    });

    document.querySelectorAll('.template-collection [aria-label="Product filter"]').forEach(function (element) {
      element.setAttribute('aria-label', 'Produktfilter');
    });

    document.querySelectorAll('.template-collection [aria-label^="Number of products:"]').forEach(function (element) {
      var anzahl = element.getAttribute('aria-label').replace(/^Number of products:\s*/i, '');
      element.setAttribute('aria-label', 'Anzahl Artikel: ' + anzahl);
    });

    document.querySelectorAll('.template-collection [aria-label^="Filter by:"]').forEach(function (element) {
      var merkmal = element.getAttribute('aria-label').replace(/^Filter by:\s*/i, '');
      element.setAttribute('aria-label', 'Filtern nach: ' + merkmal);
    });

    document.querySelectorAll('.template-collection [aria-label="Close filter tree"]').forEach(function (element) {
      element.setAttribute('aria-label', 'Filter schließen');
    });

    document.querySelectorAll('.template-collection .boost-sd__pagination-number').forEach(function (element) {
      var seite = element.textContent.trim();
      if (seite) element.setAttribute('aria-label', 'Seite ' + seite);
      if (element.classList.contains('boost-sd__pagination-number--active')) {
        element.setAttribute('aria-current', 'page');
      } else {
        element.removeAttribute('aria-current');
      }
    });

    document.querySelectorAll('.template-collection .boost-sd__pagination-button--next').forEach(function (element) {
      element.setAttribute('aria-label', 'Nächste Seite');
    });

    document.querySelectorAll('.template-collection .boost-sd__pagination-button--previous').forEach(function (element) {
      element.setAttribute('aria-label', 'Vorherige Seite');
    });
  }

  function vormerken() {
    if (geplant) return;
    geplant = true;
    window.requestAnimationFrame(eindeutschen);
  }

  function start() {
    eindeutschen();
    new MutationObserver(vormerken).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
